'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var colors = exports.colors = {
    white: '#fff',
    action1: '#1da1f2',
    action1Hover: '#1C8FD6',
    action1reduced20: '#e9f6fe',
    action2: '#3D7AF1',
    action2Hover: '#3269D4',
    black1: '#202020',
    black2: '#202020',
    black3: '#35353A',
    neutral1: '#757575',
    dawn: '#808080',
    nebula: '#9e9e9e',
    neutral1Reduced60: '#C8C8C8',
    neutral2: '#BABABA',
    saruman: '#bababa',
    neutral2Reduced60: '#E3E3E3',
    radagast: '#D8D8D8',
    neutral3: '#EDEDED',
    gandalf: '#EDEDED',
    neutral3Reduced60: '#F8F8F8',
    neutral4: '#f8f8f8',
    dust: '#fafafa',
    alert: '#EE5A5A',
    notification: '#EABA10',
    confirmation: '#47CC5D',
    porcelainGrey: '#E6E8E9',
    mint: '#21D0CF',
    adaptBlue: '#3D7AF1',
    deep: '#5D5EF6'
};
var gradients = exports.gradients = {
    dark: 'linear-gradient(90deg, #232526 0%, #414345 100%);',
    light: 'linear-gradient(90deg, #FFFFFF 0%, #F1F0F0 100%);',
    branded: 'linear-gradient(126.5deg, #2960CC 29.42%, #1DA1F2 115.43%);',
    branded1: 'linear-gradient(132.65deg, #5D5EF6 41.52%, #A05DF6 100%);',
    branded2: 'linear-gradient(69.98deg, #6587FF 1.34%, #21D0CF 82.98%);'
};
var fontSizes = exports.fontSizes = {
    h0: '32px',
    h1: '24px',
    h2: '20px',
    h3: '18px',
    h4: '16px',
    h5: '14px',
    h6: '12px',
    h7: '10px'
};
var notificationBarColors = exports.notificationBarColors = {
    success: {
        backgroundColor: 'rgba(54, 193, 126, 0.1)',
        borderColor: '#36C17E'
    },
    error: {
        backgroundColor: 'rgba(238, 90, 90, 0.1)',
        borderColor: '#EE5A5A'
    },
    warning: {
        backgroundColor: 'rgba(234, 186, 16, 0.1)',
        borderColor: '#EABA10'
    },
    info: {
        backgroundColor: 'rgba(29, 161, 242, 0.1)',
        borderColor: '#1DA1F2'
    },
    neutral: {
        backgroundColor: '#EDEDED',
        borderColor: null
    }
};
var lineHeights = exports.lineHeights = {
    small: {
        h0: '50px',
        h1: '34px',
        h2: '28px',
        h3: '26px',
        h4: '22px',
        h5: '20px',
        h6: '18px',
        h7: '12px'
    },
    big: {
        h0: '60px',
        h1: '40px',
        h2: '34px',
        h3: '32px',
        h4: '26px',
        h5: '24px',
        h6: '22px',
        h7: '16px'
    }
};
var fontWeights = exports.fontWeights = {
    black: 900,
    bold: 700,
    regular: 400,
    light: 300
};
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/data/theme.js
// module id = 1506
// module chunks = 0